<!--
 * @Author: wangwang 2723008256@qq.com
 * @Date: 2023-08-11 09:06:57
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @LastEditTime: 2025-02-28 16:04:31
 * @FilePath: \jzjypc4.2\src\components\yuyueBox\yuyuebox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yuyueevm">
      <el-dialog  :visible.sync="dialogVisible" :before-close="handleClose" width="480px" top="30vh">
        <div class="yyevmContent">
          <div class="top">
            <!-- <h4>评分反馈</h4> -->
            <h5>这份资源怎么样，请您来评价一下吧~</h5>
          </div>
          <div class="rate" @mouseleave="yikai">
            <div class="xing" v-for="(item,index) in 5" :key="index" @mouseover="huadong(index)" @click="chodeRate(index)">
              <img src="../../assets/img/5.0/ziyuan (1).png" alt="" v-if="index+1<=num">
              <img src="../../assets/img/5.0/ziyuan (2).png" alt="" v-if="index+1>num">
              <p v-if="index== 0">很差</p>
              <p v-if="index== 1">较差</p>
              <p v-if="index== 2">一般</p>
              <p v-if="index== 3">很好</p>
              <p v-if="index== 4">非常好</p>
            </div>
          </div>
          <div class="tips">*点击星星即可完成评分</div>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  props:['zykf_file_url','xzMsg'],
  inject: ["reload"],
    data(){
        return{
          dialogVisible:true,
          dqkfevm:'',//公众号二维码
          width:'560px',
          right_left:'60px',
          num:0,
          true_num:0,
        }
    },
    created(){
      console.log(this.xzMsg)
      
    },
    methods:{
      huadong(index){
        this.num = index + 1
      },
      chodeRate(index){
        this.num = this.true_num = index + 1
        this.$emit('chsoedRate',this.true_num)
      },
      yikai(){
        if(this.true_num == 0){
          this.num = 0
        }else{
          this.num = this.true_num
        }
      },
      handleClose(){
        this.$emit('qwtcClose')
      },
    },
}
</script>

<style lang="less" scoped>
    .yuyueevm {
    // /deep/.el-dialog__header {
    //   padding: 0;
    // }
    /deep/.el-dialog {
      margin-top: 13vh !important;
      border-radius: 20px;
    }
    /deep/.el-dialog__body {
      padding: 0;
      // height: 450px;
      height: 100%!important;
    }
    /deep/.el-dialog__headerbtn .el-dialog__close{
        // color: #FFF !important;
        right: 10px !important;
    }
    .yyevmContent {
      // height: 300px;
      .top {
        h4{
          // margin-bottom: 35px;
          font-size: 18px;
          color: #333333;
          text-align: center;
        }
        h5{
          margin-top: 30px;
          font-size: 18px;
          color: #333333;
          text-align: center;
        }
      }
      .rate{
        display: flex;
        align-items: center;
        margin-left: 50px;
        margin-top: 40px;
        .xing{
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 20px;
          width: 60px;
          cursor: pointer;
          p{
            margin-top: 6px;
          }
        }
      }
      .tips{
        margin-top: 40px;
        margin-bottom: 30px;
        text-align: center;
        font-size: 14px;
        color: #999999;
      }
    }
  }
</style>